export enum DataType {
    STRING = 'STRING', NUMBER = 'NUMBER', DATE='DATE', DECIMAL='DECIMAL', BOOLEAN='BOOLEAN', LOOKUP='LOOKUP', OTHERS='OTHERS', DICTIONARY='DICTIONARY', DATA_DICTIONARY='DATA_DICTIONARY'
}